import { Component,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { ISortableFilter }          from './../common/sortable-filter';
import { SupplierService }          from './../shared/supplier.service';
import { PeakService }              from './../shared/peak.service';
import { SupplierSortableFilter }   from './supplier-sortable-filter';
import { SupplierDialogComponent }  from './../supplier-dialog/supplier-dialog.component';
import { MatDialog }                 from '@angular/material';
import { Globals }                  from './../common/globals';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { SupplierModel }            from './../supplier-dialog/supplier.model';
import { MatSnackBar }               from '@angular/material';


@Component({
  selector: 'sa-supplier-list',
  template: require('./supplier-list.component.html'),
  styles: [require('./supplier-list.component.scss')]
})
export class SupplierListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new SupplierSortableFilter('companyName');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: SupplierService;
  private peakService: PeakService;

  constructor(
    apiService: SupplierService,
    peakService: PeakService,
    private dialog: MatDialog,
    public globals: Globals,
    public snackbar: MatSnackBar
  ) {
    this.apiService = apiService;
    this.peakService = peakService;
    this.getDataCallback = this.getData.bind(this);
    this.filter.activeOnly = true;

    this.columns = [
      new TableColumn(TableColumnType.Text, 'companyName', 'Jméno firmy', 250),
      new TableColumn(TableColumnType.Text, 'supplierId', 'ID', 60),
      new TableColumn(TableColumnType.Text, 'companyLin', 'IČ', 150),
      new TableColumn(TableColumnType.Text, 'companyTin', 'DIČ', 150),
      // new TableColumn(TableColumnType.Text, 'firstName', 'Jméno', 150),
      // new TableColumn(TableColumnType.Text, 'lastName', 'Příjmení', 150),
      new TableColumn(TableColumnType.Text, 'street', 'Ulice', 150),
      new TableColumn(TableColumnType.Text, 'houseNumber', 'Č.p.', 60),
      new TableColumn(TableColumnType.Text, 'city', 'Město', 150),
      new TableColumn(TableColumnType.Text, 'zipCode', 'PSČ', 60),
      new TableColumn(TableColumnType.Text, 'email', 'Email', 150),
      new TableColumn(TableColumnType.Text, 'phoneNr', 'Telefon', 150)
    ];
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(SupplierDialogComponent);
    dialogRef.componentInstance.model = new SupplierModel();
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: SupplierModel) {
    let dialogRef = this.dialog.open(SupplierDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;
    let snack = this.snackbar;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.supplierUid, dialogRef.componentInstance.model)
          .subscribe(res => {
              snack.open('Uloženo.', '', {duration: 3000});
            },
            err => {
              snack.open('Při ukládání se vyskytla chyba.', 'Zavřít');
            },
            () => {
              cloakRef.close();
              this.search();
            });
      } else if (result === 'delete') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.deleteItem(dialogRef.componentInstance.model.supplierUid)
          .subscribe(
            data => {
              snack.open('Položka byla odstraněna.', '', {duration: 3000});
            },
            err => {
              snack.open('Vybraná položka nemohla být odstraněna.', 'Zavřít');
            },
            () => {
              this.search();
              cloakRef.close();
            }
          );
      } else {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/supplier-list/supplier-list.component.ts